<template>
  <div v-if="isReady">
    <template v-if="electionPeriod">
      <icon-router-link icon="chevron-left" to="/pk/forside">Tilbake</icon-router-link>
      <div class="uppercase font-bold text-gray-500 mt-6">Valgperiode: {{ electionPeriod.name }}</div>


        <!-- header -->
        <div class="flex justify-between items-center mb-4">
          <h1 class="text-4xl font-bold tracking-tight leading-none text-gray-600">Særplasser</h1>
          <div class="flex items-center">
            <router-link class="ml-6 btn btn-primary" :to="{ name: 'pk-special-create'}">Tildel ny</router-link>
            <a href="#" @click.prevent="onDelete" class="ml-4 btn btn-primary" v-if="selected.length > 0">
              <font-awesome-icon :icon="['far', 'trash']" />
            </a>
          </div>
        </div>

        <!-- table -->
        <panel class="p-4 mb-8">
          <data-table
            :headers="headers"
            :items="practiceSlots"
            :showSelect="true"
            identifier="practiceSlotId"
            v-model="selected"
            v-if="practiceSlots.length > 0"
            @click="onClick">
          </data-table>
          <div class="text-center italic" v-else>
            Ingen særplasser registrert.
          </div>
        </panel>

    </template>
    <template v-else>
      Ingen aktiv valgperiode.
    </template>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'pk-special-list',
  data () {
    return {
      isReady: false,
      search: '',
      headers: [
        { text: 'Student', align: 'left', value: 'studentName' },
        { text: 'Grad', align: 'left', value: 'studyDisplay' },
        { text: 'Praksisperiode', align: 'left', value: 'practicePeriodName' },
        { text: 'Apotek', align: 'left', value: 'pharmacyName' },
      ],
      electionPeriod: null,
      practicePeriods: [],
      practiceSlots: [],
      selected: [],
    }
  },
  methods: {
    onClick () {
      //this.$router.push({ name: 'pk-students-edit', params })
    },
    async onDelete () {
      for (let i = 0; i < this.selected.length; i++) {
        await api.pk.unassignPracticeSlotSpecial(this.selected[i].practiceSlotId)
      }
      this.practiceSlots = await api.pk.getPracticeSlotsSpecial()
      this.$toasted.show('Særplasstildeling slettet')
    }
  },
  async created () {
    this.electionPeriod = await api.pk.getElectionPeriod()
    this.practiceSlots = await api.pk.getPracticeSlotsSpecial()
    this.isReady = true
  }
}
</script>